function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect, useState, useReducer } from "react";
import smile from "../../assets/images/smile.png";
import cry from "../../assets/images/cry.png";
import closeSmallLine from "../../assets/images/closeSmallLine.png";
import { useLocation } from "react-router-dom";
import { getSurveyInfo, getSurveyVisible, submit } from "../../service";
import RateSuccess from "../Success/index";
import "./index.less";
var prefix = 'rate-modal';
function reducer(state, action) {
  switch (action.type) {
    case 'updateScore':
      return _objectSpread(_objectSpread({}, state), {}, {
        score: action.payload,
        multipleValue: {}
      });
    case 'updateMultiple':
      var _action$payload = action.payload,
        multipleId = _action$payload.multipleId,
        id = _action$payload.id;
      var obj = state.multipleValue[multipleId] || {};
      return _objectSpread(_objectSpread({}, state), {}, {
        multipleValue: _defineProperty({}, multipleId, _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, id, !obj[id])))
      });
    case 'updateAnswerQuestion':
      return _objectSpread(_objectSpread({}, state), {}, {
        answerQuestion: action.payload
      });
    case 'init':
      return {
        multipleValue: {},
        score: {
          id: null,
          value: null
        },
        answerQuestion: {
          id: null,
          value: null
        }
      };
    default:
      throw new Error();
  }
}
var initValue = {
  multipleValue: {},
  score: {
    id: null,
    value: ''
  },
  answerQuestion: {
    id: null,
    value: ''
  }
};

// const throttle = (callback: () => void, delay: number) => {
//     let timerId: number = 0;
//     return function () {
//         if (!timerId) {
//             callback();
//             timerId = setTimeout(() => {
//                 timerId = 0;
//             }, delay);
//         }
//     };
// }

var timer = 0;
var RateModal = function RateModal(_ref) {
  var appKey = _ref.appKey,
    router = _ref.router;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    successVisible = _useState6[0],
    setSuccessVisible = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    scoreInfo = _useState8[0],
    setScoreInfo = _useState8[1]; // 
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    multipleQuestions = _useState10[0],
    setMultipleQuestions = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    visibleTime = _useState12[0],
    setVisibleTime = _useState12[1];
  // @ts-ignore
  var _useReducer = useReducer(reducer, initValue),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    errMessage = _useState14[0],
    setErrMessage = _useState14[1]; // 错误提示
  var location = useLocation();
  useEffect(function () {
    if (router) return;
    onHashChange();
  }, [location]);
  useEffect(function () {
    // 目前react-router-dom中无法监听到Vue3路由的变化，顾此在vue3项目中采用传递router，之后监听的方法来处理路由的切换
    if (!router) return;
    onHashChange();
    router.beforeEach(function (to, form, next) {
      next === null || next === void 0 ? void 0 : next();
      onHashChange(to.href);
    });
  }, []);
  var onHashChange = function onHashChange(href) {
    if (timer) {
      clearTimeout(timer);
    }
    init();
    getRateInfo(href || location.pathname);
  };
  var init = function init() {
    setVisible(false);
    setVisibleTime(0);
    setSuccessVisible(false);
    setErrMessage('');
    dispatch({
      type: 'init'
    });
  };

  // 获取当前页面是否有问卷
  var getRateInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(pathname) {
      var _content$answerQuesti, _content$scoreQuestio, startTime, params, data, endTime, time, content, value, multipleObj;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (pathname) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            startTime = Date.now();
            params = {
              pageCode: pathname
            };
            _context.next = 7;
            return getSurveyInfo(params, appKey);
          case 7:
            data = _context.sent;
            if (data !== null && data !== void 0 && data.name) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return");
          case 10:
            // 如果没有调研名称，说明不展示
            endTime = Date.now();
            time = data.triggerIntervalSeconds * 1000 - (endTime - startTime);
            if (time > 0) {
              // 校验接口登录耗时是不是已经超过需要在页面停留的时间了
              timer = setTimeout(function () {
                handleVisible({
                  pageCode: pathname,
                  templateId: data.id,
                  appKey: appKey
                });
              }, time);
            } else {
              handleVisible({
                pageCode: pathname,
                templateId: data.id,
                appKey: appKey
              });
            }
            content = JSON.parse(data.content);
            value = _objectSpread(_objectSpread(_objectSpread({}, data), content), {}, {
              answerQuestion: content === null || content === void 0 ? void 0 : (_content$answerQuesti = content.answerQuestions) === null || _content$answerQuesti === void 0 ? void 0 : _content$answerQuesti[0],
              // 后端数据结构问题，默认取第一个
              scoreQuestion: content === null || content === void 0 ? void 0 : (_content$scoreQuestio = content.scoreQuestions) === null || _content$scoreQuestio === void 0 ? void 0 : _content$scoreQuestio[0]
            });
            setScoreInfo(value);
            multipleObj = {}; // 遍历处理，为选择满意度之后，自动变化多选题做处理，减少复杂度
            value.multipleQuestions.forEach(function (item) {
              item.scoreRequired.forEach(function (score) {
                multipleObj[score] = item;
              });
            });
            setMultipleQuestions(multipleObj);
            _context.next = 24;
            break;
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](0);
            console.log('ksll-nps-error', _context.t0);
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 21]]);
    }));
    return function getRateInfo(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  // 处理展示逻辑
  var handleVisible = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
      var res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return getSurveyVisible(params, appKey);
          case 3:
            res = _context2.sent;
            if (res.push) {
              setVisible(true);
              setVisibleTime(Date.now()); // 记录展示出来的时间，为记录填写时常做准备
            }
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            console.log('ksll-nps-error', _context2.t0);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function handleVisible(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleClose = function handleClose() {
    setVisible(false);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var params, answers, res;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!loading) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            setLoading(true);
            params = {
              costTime: Math.round((Date.now() - visibleTime) / 1000),
              pageCode: location.pathname,
              templateId: scoreInfo.id,
              appKey: appKey
            };
            answers = [];
            answers.push({
              // 评分
              questionId: state.score.id,
              answer: state.score.value && [state.score.value]
            });
            if (state.answerQuestion.id) {
              answers.push({
                // 问答题
                questionId: state.answerQuestion.id,
                answer: state.answerQuestion.value ? [state.answerQuestion.value] : []
              });
            }
            Object.keys(state.multipleValue).forEach(function (multipleId) {
              var arr = [];
              Object.keys(state.multipleValue[multipleId]).forEach(function (id) {
                if (state.multipleValue[multipleId][id]) {
                  arr.push(id);
                }
              });
              if (arr.length) {
                answers.push({
                  questionId: multipleId,
                  answer: arr
                });
              }
            });
            params.answers = answers;
            _context3.prev = 9;
            _context3.next = 12;
            return submit(params, appKey);
          case 12:
            res = _context3.sent;
            if (res.status === 1) {
              setVisible(false);
              setSuccessVisible(true);
              setTimeout(function () {
                setSuccessVisible(false);
              }, 3000);
            } else {
              setErrMessage(res.message || '问卷填写错误');
            }
            _context3.next = 19;
            break;
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](9);
            console.log('ksll-nps-error', _context3.t0);
          case 19:
            _context3.prev = 19;
            setTimeout(function () {
              // 因为目前有1秒钟动画延迟，所以做1秒的间隔，避免连点的出现
              setLoading(false);
            }, 1000);
            return _context3.finish(19);
          case 22:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[9, 16, 19, 22]]);
    }));
    return function handleSubmit() {
      return _ref4.apply(this, arguments);
    };
  }();

  // const throttleSubmit = throttle(handleSubmit, 3000);

  var Multiple = function Multiple() {
    var multipleItem = multipleQuestions[state.score.value] || {};
    if (!multipleItem.options) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-content-checkbox")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-content-checkbox-title")
    }, multipleItem.question), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-content-checkbox-list")
    }, multipleItem.options.map(function (subItem, index) {
      var _state$multipleValue$;
      return /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return dispatch({
            type: 'updateMultiple',
            payload: {
              multipleId: multipleItem.id,
              id: subItem.id
            }
          });
        },
        key: index,
        className: "".concat(prefix, "-content-checkbox-tag ").concat((_state$multipleValue$ = state.multipleValue[multipleItem.id]) !== null && _state$multipleValue$ !== void 0 && _state$multipleValue$[subItem.id] ? 'check' : '')
      }, subItem.desc);
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, scoreInfo.scoreQuestion && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, " ").concat(visible ? "open" : "")
  }, /*#__PURE__*/React.createElement("section", {
    className: "".concat(prefix, "-header")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-title")
  }, scoreInfo.scoreQuestion.question), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-close"),
    onClick: function onClick() {
      return handleClose();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: closeSmallLine,
    alt: "",
    style: {
      width: '30px',
      verticalAlign: 'middle'
    }
  }))), /*#__PURE__*/React.createElement("section", {
    className: "".concat(prefix, "-content")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-rate")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-rate-text")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-rate-text-item")
  }, /*#__PURE__*/React.createElement("img", {
    src: cry,
    alt: "",
    className: "".concat(prefix, "-content-rate-text-icon")
  }), /*#__PURE__*/React.createElement("span", null, scoreInfo.scoreQuestion.lowLegend)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-rate-text-item")
  }, /*#__PURE__*/React.createElement("img", {
    src: smile,
    alt: "",
    className: "".concat(prefix, "-content-rate-text-icon")
  }), /*#__PURE__*/React.createElement("span", null, scoreInfo.scoreQuestion.highLegend))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-rate-list")
  }, Array.from({
    length: scoreInfo.scoreQuestion.scale
  }, function (v, i) {
    return i + 1;
  }).map(function (num) {
    return /*#__PURE__*/React.createElement("span", {
      key: num,
      onClick: function onClick() {
        return dispatch({
          type: 'updateScore',
          payload: {
            id: scoreInfo.scoreQuestion.id,
            value: num
          }
        });
      },
      className: "".concat(prefix, "-content-rate-item ").concat(state.score.value === num ? 'check' : '')
    }, num);
  }))), /*#__PURE__*/React.createElement(Multiple, null), scoreInfo.answerQuestion && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-textarea")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-textarea-title")
  }, scoreInfo.answerQuestion.question), /*#__PURE__*/React.createElement("textarea", {
    onChange: function onChange(e) {
      return dispatch({
        type: 'updateAnswerQuestion',
        payload: {
          id: scoreInfo.answerQuestion.id,
          value: e.target.value
        }
      });
    },
    value: state.answerQuestion.value || '',
    placeholder: scoreInfo.answerQuestion.tips,
    className: "".concat(prefix, "-content-textarea-input")
  })), errMessage && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-error")
  }, errMessage)), /*#__PURE__*/React.createElement("section", {
    className: "".concat(prefix, "-footer")
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleSubmit,
    className: "".concat(prefix, "-footer-btn")
  }, "\u63D0\u4EA4"))), /*#__PURE__*/React.createElement(RateSuccess, {
    visible: successVisible,
    handleClose: function handleClose() {
      return setSuccessVisible(false);
    }
  }));
};
export default RateModal;